module.exports = __webpack_public_path__ + "img/section-1.367926d7.gif";